import { useTranslation } from 'react-i18next';
import { useSound } from '../hooks/useSound';
import Portfolio from './Portfolio';

interface PortfolioPanelProps {
  onSlideRight: () => void;
}

export default function PortfolioPanel({ onSlideRight }: PortfolioPanelProps) {
  const { t } = useTranslation('landing');
  const { playNote } = useSound();

  const portfolioItems = t('portfolio.items', { returnObjects: true }) as Array<{
    title: string;
    category: string;
    description: string;
    image: string;
  }>;

  return (
    <div className="h-full overflow-y-auto bg-[var(--navy-deep)] text-white landing-scrollbar">
      {/* Back button */}
      <div className="sticky top-0 z-20 p-4">
        <button
          onClick={onSlideRight}
          className="w-10 h-10 rounded-full bg-white/10 border border-white/10 text-gray-300 hover:text-white hover:bg-white/20 transition-all duration-200 flex items-center justify-center"
          title="Back"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>

      <div className="pt-4 pb-24">
        <Portfolio
          title={t('portfolio.title')}
          subtitle={t('portfolio.subtitle')}
          items={portfolioItems}
          isVisible={true}
          onPlayNote={playNote}
          viewLabel={t('portfolio.viewLabel')}
          closeLabel={t('portfolio.closeLabel')}
        />
      </div>
    </div>
  );
}
